import React from 'react'
import Dashboard from '../dashboard/Dashboard'

const Home = () => {
  return (
    <>
    <Dashboard/>
    </>
  )
}

export default Home